import { useCallback, useState } from "react";

export const useCenteredTree = () => {
    const [translate, setTranslate] = useState({ x: 0, y: 0 });
    const containerRef = useCallback((containerElem) => {
        if (containerElem !== null) {
            const { width, height } = containerElem.getBoundingClientRect();
            setTranslate({ x: width / 7.5, y: height / 2.25 }); // 2, 7.5
        }
    }, []);
    return [translate, containerRef];
};
